// extracted by mini-css-extract-plugin
export var copyableField = "_r9-4";
export var customerBadge = "_r9-0";
export var customerInfoTitle = "_r9-2";
export var details = "_r9-1";
export var dropdownContainer = "_r9-5";
export var dropdownImage = "_r9-6";
export var editAssigneeForm = "_r9-a";
export var editButton = "_r9-3";
export var email = "_r9-7";
export var hidden = "_r9-d";
export var input = "_r9-8";
export var saveButton = "_r9-b";
export var shopifyIcon = "_r9-c";
export var suggestionBadge = "_r9-e";
export var suggestionText = "_r9-f";
export var username = "_r9-9";